import IbmPaymentIframeContainer from './IbmPaymentIframeContainer';

export default IbmPaymentIframeContainer;
